import { Link, useParams } from "react-router-dom";
import { api } from "../lib/api";
import { useAsync } from "../lib/useAsync";
import { Page, Spinner, ErrorBox } from "../components/ui";
import { PollWidget } from "../components/PollWidget";
import { Share } from "../components/Share";
import { pollShareUrl } from "@shared/share-links";
import { usePageTitle } from "../lib/usePageTitle";
import { useT } from "../i18n";

// Shareable single-poll page: /polls/:id. The list keeps inline voting; this
// is the deeplink target (Discord unfurls, in-game links) with its own Share.
export default function PollDetail() {
  const t = useT();
  const { id = "" } = useParams();
  const { data, loading, error } = useAsync(() => api.poll(id), [id]);
  usePageTitle(data ? data.question : null);
  // Country name/flag for the scope tag, only when the poll is nation-scoped.
  const countries = useAsync(() => api.countries(), []);
  const scope = data
    ? data.countryId
      ? (countries.data ?? []).find((c) => c.id === data.countryId) ?? { name: "Unknown", code: "" }
      : ("global" as const)
    : undefined;

  return (
    <Page>
      <div className="flex items-center justify-between gap-2 my-3">
        <Link to="/polls" className="text-accent text-sm">← {t("polls.allPolls")}</Link>
        {data && <Share title={data.question} text={t("polls.shareText")} url={pollShareUrl(data.id)} />}
      </div>
      {loading && <Spinner label={t("polls.loadingPoll")} />}
      {error && <ErrorBox msg={error} />}
      {data && <PollWidget poll={data} scope={scope} />}
    </Page>
  );
}
